import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "../../context/AuthContext";
import { KYC_PENDING as T } from "../../config/zinihubConfig";
import { Breadcrumb } from "../../components/Breadcrumb";
import styles from "./KYC.module.css";

const KYCPending = () => {
  const { token, decodeToken } = useAuth();
  const navigate = useNavigate();

  const decodedToken = useMemo(() => decodeToken(token), [token, decodeToken]);

  if (!decodedToken) {
    return (
      <div className={styles.loadingWrap}>
        <Spin size="large" />
        <p className={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <Breadcrumb items={[
        { label: 'Hub Settings', path: '/hubSettings' },
        { label: 'KYC Verification' }
      ]} />
      <div className={styles.topRow}>
        <div className={styles.backBtn} onClick={() => navigate("/hubSettings")}>
          {T.BACK_BTN}
        </div>
        <div className={styles.pageTitle}>{T.PAGE_TITLE}</div>
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionTitle}>{T.UNLOCK_TITLE}</div>
        {T.UNLOCK_ITEMS.map(({ icon, title, desc }) => (
          <div key={title} className={styles.benefitRow}>
            <div className={styles.benefitIcon}>{icon}</div>
            <div className={styles.benefitContent}>
              <div className={styles.benefitTitle}>{title}</div>
              <div className={styles.benefitDesc}>{desc}</div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionTitle}>{T.NEED_TITLE}</div>
        {T.NEED_ITEMS.map(({ icon, title, desc, required }) => (
          <div key={title} className={styles.needRow}>
            <span className={styles.needIcon}>{icon}</span>
            <div className={styles.needContent}>
              <div className={styles.needTitle}>{title}</div>
              <div className={styles.needDesc}>{desc}</div>
            </div>
            <span
              className={`${styles.needBadge} ${required ? styles.needBadgeRequired : styles.needBadgeOptional}`}
            >
              {required ? "Required" : "Optional"}
            </span>
          </div>
        ))}
      </div>

      <div className={styles.primaryBtn} onClick={() => navigate("/hubSettings/kyc/upload")}>
        {T.START_BTN}
      </div>
    </div>
  );
};

export default KYCPending;
